"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _this = this;
Object.defineProperty(exports, "__esModule", { value: true });
var next_1 = require("@alifd/next");
var Cookie = require("js-cookie");
var base_1 = require("./base");
var ting = {
    10102: "江干行政服务中心",
    10201: "衢州行政服务中心",
    10101: "杭州市民中心",
};
var DeviceCookie = {
    pad: "binded",
    idCard: "IdCardType",
    gyp: "GpyType",
};
var util = {
    getDeviceStatus: function () {
        var pad = Cookie.get(DeviceCookie.pad);
        var gpy = Cookie.get(DeviceCookie.gyp);
        var idCard = Cookie.get(DeviceCookie.idCard);
        return {
            pad: pad === "0" ? false : true,
            gpy: !!gpy,
            idCard: !!idCard,
        };
    },
    getHost: function () {
        var portalHost = "//portal.zjzwfw.gov.cn"; // 默认
        var receptHost = "//recept.zjzwfw.gov.cn";
        if (location.host.indexOf("pre-") >= 0) {
            // 预发
            portalHost = "//pre-portal.zjzwfw.gov.cn";
            receptHost = "//pre-recept.zjzwfw.gov.cn";
        }
        else if (location.host.indexOf("poc-") >= 0) {
            // 增加 poc 环境
            portalHost = "//poc-portal.gov-devops.alibaba.com";
            receptHost = "//poc-recept.gov-devops.alibaba.com";
        }
        else if (location.host.indexOf("portal.zjzwfw") >= 0 ||
            location.host.indexOf("recept.zjzwfw") >= 0) {
            // 线上
            portalHost = "//portal.zjzwfw.gov.cn";
            receptHost = "//recept.zjzwfw.gov.cn";
        }
        else {
            // 日常
            // portalHost = `//${location.host}`;
            // receptHost = `//${location.host}`;
            portalHost = "//govtest.zjzwfw.gov.cn";
            receptHost = "//govtest.zjzwfw.gov.cn";
        }
        return {
            portalHost: "" + location.protocol + portalHost,
            receptHost: "" + location.protocol + receptHost,
        };
    },
    get: function (url, data) { return __awaiter(_this, void 0, Promise, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, base_1.default({
                    url: url,
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    params: data,
                })];
        });
    }); },
    post: function (url, data) {
        // 这里要修改城request请求 ，并且修改cookie header信息
        return base_1.default({
            url: url,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            data: data,
        });
    },
    isLegal: function () {
        return Cookie.get("clientUserType") === "legal";
    },
    getDymanicDomain: function () {
        var domain = document.domain;
        if (domain.indexOf("gov.cn") !== -1) {
            return "." + domain.split(".").slice(-3).join(".");
        }
        else {
            return window.location.hostname;
        }
    },
    bin2hex: function (s) {
        // tslint:disable-next-line:one-variable-per-declaration
        var i = 0, l = 0, o = "", n;
        s += "";
        for (i = 0, l = s.length; i < l; i++) {
            n = s.charCodeAt(i).toString(16);
            o += n.length < 2 ? "0" + n : n;
        }
        return o;
    },
    getUuid: function () {
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        var txt = "http://www.zjzwfw.gov.cn/";
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        var b64 = canvas.toDataURL().replace("data:image/png;base64,", "");
        var bin = atob(b64);
        return _this.bin2hex(bin.slice(-16, -12));
    },
    encode: function (param) {
        if (!param) {
            return "";
        }
        var _a = param.hallId, hallId = _a === void 0 ? "" : _a, _b = param.type, type = _b === void 0 ? "" : _b, _c = param.deviceType, deviceType = _c === void 0 ? "" : _c;
        return hallId + "&" + type + "&" + deviceType;
    },
    decode: function (param) {
        if (!param) {
            return {};
        }
        var paramArr = param.split("&") || [];
        var hallId = paramArr[0], type = paramArr[1], device = paramArr[2];
        return {
            hallId: hallId,
            type: type,
            device: device,
        };
    },
    checkAccount: function (props) {
        var name = props.cardName || props.name;
        var card = props.cardNumber || props.num || "";
        var isIdCard = props.cardType === "1"; // 1, 代表身份证
        if (!name) {
            next_1.Message.error("姓名不能为空");
            return false;
        }
        if (isIdCard && !/(^\d{15}$)|(^\d{17}([0-9]|X)$)/.test(card)) {
            next_1.Message.error("身份证格式错误");
            return false;
        }
        if (!card) {
            next_1.Message.error("证件不能为空");
            return false;
        }
        return true;
    },
    getIdCardInfo: function (type) {
        if (type === void 0) { type = "idtype"; }
        return __awaiter(_this, void 0, void 0, function () {
            var info, _a, data, content, options, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, util.post("/newHall/uc/common/dict", {
                                type: type,
                                extras: { accountType: Cookie.get("clientUserType") || "person" },
                            })];
                    case 1:
                        info = _b.sent();
                        _a = (info || {}).data, data = _a === void 0 ? {} : _a;
                        content = data.content || [];
                        options = content.map(function (item) { return ({
                            label: item.value,
                            value: item.key,
                        }); });
                        return [2 /*return*/, options];
                    case 2:
                        error_1 = _b.sent();
                        throw error_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    },
    doLogin: function (params, successCB, errorCB) { return __awaiter(_this, void 0, void 0, function () {
        var _a, _b, success, _c, data, _d, errorMsg, error_2;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _e.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, util.post("/newHall/uc/login", params)];
                case 1:
                    _a = _e.sent(), _b = _a.success, success = _b === void 0 ? false : _b, _c = _a.data, data = _c === void 0 ? {} : _c, _d = _a.errorMsg, errorMsg = _d === void 0 ? "" : _d;
                    if (success && data) {
                        GovCookie.personSet({
                            psid: data.userId,
                            username: data.userName,
                            type: Cookie.get("clientUserType") || "person",
                        });
                        successCB(data);
                    }
                    else {
                        errorCB();
                        next_1.Message.error(errorMsg);
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_2 = _e.sent();
                    throw error_2;
                case 3: return [2 /*return*/];
            }
        });
    }); },
    getReceivingChannel: function () {
        // const platform = navigator.platform.toLowerCase();
        var userAgent = navigator.userAgent.toLowerCase();
        var isAliapy = /alipayclient/.test(userAgent);
        var isZLB = /dtdreamweb|zlbnewweb/.test(userAgent);
        var href = location.href.toString();
        if (window.receivingChannel) {
            return window.receivingChannel;
        }
        else if (href.indexOf("offline-intg") >= 0) {
            return "offline-intg";
        }
        else if (href.indexOf("offline-pad") >= 0) {
            return "offline-pad";
        }
        else if (isAliapy) {
            return "h5-alipay";
        }
        else if (isZLB) {
            return "h5-zlb";
        }
        else {
            return "default";
        }
    },
    getOperationSystem: function () {
        var platform = navigator.platform.toLowerCase();
        var userAgent = navigator.userAgent.toLowerCase();
        if (platform.indexOf("mac") >= 0) {
            return "macos";
        }
        else if (platform.indexOf("win") >= 0) {
            return "windows";
        }
        else if (/linux/i.test(userAgent)) {
            return "linux";
        }
        else {
            return "other";
        }
    },
    getDeviceType: function () {
        if (/(iphone|ios)/i.test(navigator.userAgent) || /(android)/i.test(navigator.userAgent)) {
            return "mobile";
        }
        else if (/(ipad)/i.test(navigator.userAgent)) {
            return "pad";
        }
        else {
            return "pc";
        }
    },
    getUserType: function () {
        return Cookie.get("clientUserType") || "person";
    },
    deviceFactor: function () {
        return {
            "gov-rc": this.getReceivingChannel(),
            "gov-os": this.getOperationSystem(),
            "gov-dt": this.getDeviceType() === "pc" ? "pc" : "h5",
            "guc-accountType": this.getUserType(),
            "guc-platform": "pc_offline",
            "guc-endpoint": "C",
            "x-gov-tenant": "zj",
            "userType": this.getUserType(),
        };
    },
};
var domain = util.getDymanicDomain();
var GovCookie = /** @class */ (function () {
    function GovCookie() {
    }
    GovCookie.goToLink = function (path) {
        if (/category/gi.test(location.href)) {
            location.reload();
        }
        else {
            location.href = location.origin + "/" + path;
        }
    };
    GovCookie.govSet = function (loginResult, data) {
        Cookie.set("govAuthCode", loginResult.data.govAuthCode, {
            domain: domain,
            path: "/",
        });
        Cookie.set("govUserName", loginResult.data.userName, {
            domain: domain,
            path: "/",
        });
        Cookie.set("departmentId", data.departmentId, {
            domain: domain,
            path: "/",
        });
        Cookie.set("departmentName", data.departmentName, {
            domain: domain,
            path: "/",
        });
    };
    GovCookie.personSet = function (result) {
        Cookie.set("personId", result.psid, {
            domain: domain,
            path: "/",
        });
        Cookie.set("personName", result.username, {
            domain: domain,
            path: "/",
        });
        Cookie.set("clientUserType", result.type || "person", {
            domain: domain,
            path: "/",
        });
        Cookie.set("clientUserAccountType", result.type || "person", {
            domain: domain,
            path: "/",
        });
    };
    GovCookie.personLogout = function (needConfirm) {
        var _this = this;
        var logout = function () { return __awaiter(_this, void 0, void 0, function () {
            var res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        Cookie.remove("personId", { domain: ".zjzwfw.gov.cn", path: "/" });
                        Cookie.remove("personName", { domain: ".zjzwfw.gov.cn", path: "/" });
                        Cookie.remove("clientUserType", { domain: ".zjzwfw.gov.cn", path: "/" });
                        Cookie.remove("clientUserAccountType", {
                            domain: domain,
                            path: "/",
                        });
                        return [4 /*yield*/, util.post("/portal/logout")];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            next_1.Message.success("退出成功");
                            this.goToLink("/newHall/smarthall-recept/category");
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if (needConfirm) {
            next_1.Dialog.confirm({
                title: "确认登出",
                onOk: function () {
                    logout();
                },
            });
        }
        else {
            logout();
        }
    };
    GovCookie.govLogout = function () {
        Cookie.remove("govAuthCode", { domain: domain, path: "/" });
        Cookie.remove("govUserName", { domain: domain, path: "/" });
        Cookie.remove("personId", { domain: domain, path: "/" });
        Cookie.remove("personName", { domain: domain, path: "/" });
        this.goToLink("pc/portal/#/login/index");
    };
    GovCookie.getDomain = function () {
        return util.getDymanicDomain();
    };
    return GovCookie;
}());
exports.GovCookie = GovCookie;
exports.default = util;
